import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'

export default function MainContent({children, className}) {
  return <div className={`${styles.root} ${className}`}>{children}</div>
}

MainContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}
